module.exports = __webpack_public_path__ + "img/icon_FAQ_application_active.2c2a60db.svg";